module.exports = __webpack_public_path__ + "static/media/slast.c82fed3d.m4a";